import React from 'react';

const Provoet = () => {
  return (
    <div className="bg-[#f7f1ea] min-w-screen max-w-screen h-[60vh] flex flex-col justify-center items-start px-10 text-[#567C49] md:mt-[-40px]">
      <h1 className="md:text-[55px] text-2xl font-bold md:mb-[70px] md:ml-[70px] mb-5">Provoet</h1>
      <p className="md:text-lg text-[13px] md:ml-[70px]">
        Bij Irma kunt u ook terecht voor een pedicure behandeling. Ik ben aangesloten bij Provoet,
        de Nederlandse branchevereniging voor pedicures. Alle leden van ProVoet worden verplicht
        om een door de branche erkend vakdiploma te halen en bijscholingen te volgen.
        Hierdoor weet u zeker dat uw voeten door een vakkundige voetverzorger behandeld
        worden! Tevens wordt gewerkt met de nieuwste technieken en natuurlijke producten met
        hoogwaardige werking welke afgestemd worden op uw behoeften en huid.
      </p>
    </div>
  );
};

export default Provoet;
